import RequestUserDataPage from './request-user-data-page'

export default RequestUserDataPage
